import { useCallback, useState } from "react";
import { getV2Pipeline } from "./service";

export default usePipelineV2;

interface UsePipelineV2 {
  pipeline: any;
  isLoading: boolean;
  getPipeline: (workspaceId: string, pipelineId: string) => void;
}

function usePipelineV2(): UsePipelineV2 {
  const [pipeline, setPipeline] = useState(undefined);
  const [isLoading, setIsLoading] = useState(true);

  const getPipeline = useCallback(async function getPipeline(
    workspaceId: string,
    pipelineId: string,
  ) {
    setIsLoading(true);

    try {
      const request = { params: { workspaceId, pipelineId } };
      const response = await getV2Pipeline(request);

      setPipeline(response.data);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  }, []);

  return {
    pipeline,
    isLoading,
    getPipeline,
  };
}
